export const TOGGLE_EDIT_MODE = 'userCollection/ui/TOGGLE_EDIT_MODE';

export const toggleEditMode = () => ({ type: TOGGLE_EDIT_MODE });
